export const USER_DEPOSIT = 'user_deposit';